export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_stavan-dev-studio/artifacts/b4jc4i8v_VELORA_SUPAR_ORIGINAL_LOGO-removebg-preview.png",
  founder:
    "https://customer-assets.emergentagent.com/job_36f4dacd-8c6b-4b3c-b925-f4160690e53c/artifacts/1655vy06_founder.jpg",
};
